// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "container-2Cc8o";
var _5 = "title-MZ8D_";
var _6 = "collapse-VeLrw";
var _7 = "additionalFields-Ilhft";
var _8 = "fieldWrapper-2De04";
var _9 = "fieldLabel-18wh3";
var _a = "labelText-2jFU_";
var _b = "validIcon-18kZB";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "container", _5 as "title", _6 as "collapse", _7 as "additionalFields", _8 as "fieldWrapper", _9 as "fieldLabel", _a as "labelText", _b as "validIcon" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "container": _4, "title": _5, "collapse": _6, "additionalFields": _7, "fieldWrapper": _8, "fieldLabel": _9, "labelText": _a, "validIcon": _b }
